import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08866b78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-select base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Picker = _resolveComponent("Picker")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["inner", { placeholder: $props.modelValue == '', disabled: $props.disabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showPopup && $setup.showPopup(...args)))
    }, _toDisplayString($setup.selectText || $props.placeholder), 3),
    _createVNode(_component_Popup, {
      show: $setup.show,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.show) = $event)),
      position: 'bottom'
    }, {
      default: _withCtx(() => [
        ($setup.show)
          ? (_openBlock(), _createBlock(_component_Picker, {
              key: 0,
              "default-index": $setup.defaultIndex,
              title: $props.placeholder,
              columns: $props.options,
              onCancel: $setup.hidePopup,
              onConfirm: $setup.handlePickerConfirm
            }, null, 8, ["default-index", "title", "columns", "onCancel", "onConfirm"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}